export default "__VITE_ASSET__BnlxWyXD__"